"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "settings.statData",
    path: "external-stat-data",
    component: "StatData"
});
let StatData = class StatData extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    statDataCategories;
    items;
    async $$load_items() {
        return this.$fn.fetch('list_stat_data').then(p => p.data);
    }
    ux;
    b_7315092382398562_modalBindings;
    b_8564662037462133_columns;
    async $$load_b_8564662037462133_columns() {
        return [{
                name: "category",
                type: "select",
                header: this.$fn.pgettext("StatData", "Category"),
                width: "280px",
                required: true,
                options: this.statDataCategories,
            },
            {
                name: "name",
                header: this.$fn.pgettext("StatData", "Name"),
                width: "120px",
                required: true,
            },
            {
                name: "source",
                header: this.$fn.pgettext("StatData", "Source"),
                width: "120px",
            },
            {
                name: "date",
                type: "date",
                header: this.$fn.pgettext("StatData", "Date"),
                width: "120px",
                required: true,
            },
            {
                name: "value",
                type: "number",
                header: this.$fn.gettext("Value"),
                width: "120px",
                required: true,
            },
            {
                name: "unit",
                header: this.$fn.gettext("Unit"),
                width: "120px",
                required: true,
            },
        ];
    }
    dataMembers = ['statDataCategories', 'items', 'ux', 'b_7315092382398562_modalBindings', 'b_8564662037462133_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                statDataCategories: [{
                        id: "exchange_rate",
                        text: this.$fn.pgettext("StatDataCategory", "Exchange rate"),
                    },
                    {
                        id: "base_rate",
                        text: this.$fn.pgettext("StatDataCategory", "Base rate"),
                    },
                    {
                        id: "inflation_index",
                        text: this.$fn.pgettext("StatDataCategory", "Inflation index"),
                    },
                ],
                items: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_8564662037462133_columns: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return;
        }
        return null;
    }
    async act_7315092382398562_closeModal_5666_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_script_5668_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('stat_data').upsert({
            ...$event.data.row,
            start: $event.data.row.lastvalue
        }));
    }
    async act_8564662037462133_script_5668_getActionArgs($event) {
        return {
            value: () => this.act_8564662037462133_script_5668_getActionArgs_value($event),
        };
    }
    async evh_8564662037462133_save(event, scope) {
        return await this.actions.evh_8564662037462133_save.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_script_5670_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('stat_data').delete($event.data.row));
    }
    async act_8564662037462133_script_5670_getActionArgs($event) {
        return {
            value: () => this.act_8564662037462133_script_5670_getActionArgs_value($event),
        };
    }
    async evh_8564662037462133_delete(event, scope) {
        return await this.actions.evh_8564662037462133_delete.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5666 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5666_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5665 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5666,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5665],
        });
        const act_8564662037462133_script_5668 = new core_1.actions.ScriptAction({
            actionArgs: this.act_8564662037462133_script_5668_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_save_5667 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_script_5668,
            event: "save",
            displayName: "script",
        });
        const evh_8564662037462133_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_save_5667],
        });
        const act_8564662037462133_script_5670 = new core_1.actions.ScriptAction({
            actionArgs: this.act_8564662037462133_script_5670_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_delete_5669 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_script_5670,
            event: "delete",
            displayName: "script",
        });
        const evh_8564662037462133_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_delete_5669],
        });
        return {
            act_7315092382398562_closeModal_5666,
            evh_7315092382398562_close_5665,
            evh_7315092382398562_close,
            act_8564662037462133_script_5668,
            evh_8564662037462133_save_5667,
            evh_8564662037462133_save,
            act_8564662037462133_script_5670,
            evh_8564662037462133_delete_5669,
            evh_8564662037462133_delete,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], StatData.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], StatData.prototype, "onSize", null);
StatData = __decorate([
    (0, vue_property_decorator_1.Component)()
], StatData);
exports.default = StatData;
vue_property_decorator_1.Vue.component("StatData", StatData);
